import axios from 'axios'

export default {

    /**
     * Get all messages sent to authenticated user
     * @param params
     * @returns {AxiosPromise<any>}
     */
    get(params) {
        return axios.get('/api/messages', { params })
    },

    /**
     * Get users.
     * @returns {AxiosPromise<any>}
     * @param data
     */
    send(data) {
        console.log('posting message', data);
        return axios.post('/api/messages', data)
    },

    /**
     * Find message
     * @param id
     * @returns {AxiosPromise<any>}
     */
    find(id) {
        return axios.get('/api/messages/' + id)
    },

    /**
     * Send message thread as seen
     * @param id
     * @returns {AxiosPromise<any>}
     */
    seen(id) {
        return axios.post('/api/messages/' + id + '/seen', { '_method': 'PUT' })
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/api/messages.js